module.exports = __webpack_public_path__ + "static/quadrant_map-6078716bc352ea8f24289455506b9dab.jpg";